import React from "react";
import AppProvider from "../../../api/appProvider";
import DesignList from "../DesignList";
import Designviews from "../Designviews";
import RoomList from "../RoomList";

const IllustrationList = ({ showSearch }) => {
  return (
    <>
      {window.flags.visualizations &&
        window.flags.visualizations.renderDesignsInVisualizationTab &&
        !AppProvider.isEcatMode && (
          <DesignList className="at-visualization-tab-designs" hidden={showSearch} />
        )}
      {window.flags.visualizations && window.flags.visualizations.renderDesignViews && (
        <Designviews />
      )}

      {!showSearch && <RoomList />}
    </>
  );
};

export default IllustrationList;
